export enum PinwheelEvents {
  Open = 'open',
  SelectEmployer = 'select_employer',
  SelectPlatform = 'select_platform',
  LoginAttempt = 'login_attempt',
  Login = 'login',
  InputAmount = 'input_amount',
  Success = 'success',
  PinWheelError = 'error',
  InputRequired = 'input_required',
  Exit = 'exit',
  DdFormBegin = 'dd_form_begin',
  DdFormCreate = 'dd_form_create',
  DdFormDownload = 'dd_form_download',
  InputAllocation = 'input_allocation',
  Other = 'other_event',
  SearchDefault = 'search_default',
  SearchResults = 'search_results',
  SearchPlatform = 'search_platform_only',
  ProviderConfirmation = 'provider_confirmation',
  DDAmountSelection = 'dd_amount_selection',
  DDConfirmation = 'dd_confirmation',
  JobSuccess = 'job_success',
  JobError = 'job_error',
  ExitConfirmation = 'exit_confirmation',
}

export const pinwheelSegmentEventNames = {
  [PinwheelEvents.SelectEmployer as string]:
    'Direct Deposit Instant Switch Employer Selected',
  [PinwheelEvents.SelectPlatform as string]:
    'Direct Deposit Instant Switch Platform Selected',
  [PinwheelEvents.LoginAttempt as string]:
    'Direct Deposit Instant Switch Login Attempted',
  [PinwheelEvents.Login as string]:
    'Direct Deposit Instant Switch Login Succeeded',
  [PinwheelEvents.InputAmount as string]:
    'Direct Deposit Instant Switch Amount Inputted',
  [PinwheelEvents.Success as string]: 'Direct Deposit Instant Switch Completed',
  [PinwheelEvents.PinWheelError as string]:
    'Direct Deposit Instant Switch Error Occurred',
  [PinwheelEvents.DdFormBegin as string]:
    'Direct Deposit Form Creation Initiated',
  [PinwheelEvents.DdFormCreate as string]: 'Direct Deposit Create Form Clicked',
  [PinwheelEvents.DdFormDownload]: 'Direct Deposit Form Download Clicked',
  [PinwheelEvents.InputAllocation as string]:
    'Direct Deposit Instant Switch Amount Inputted',
  [PinwheelEvents.SearchDefault]:
    'Direct Deposit Instant Switch Search Default',
  [PinwheelEvents.SearchResults]:
    'Direct Deposit Instant Switch Search Results',
  [PinwheelEvents.SearchPlatform]:
    'Direct Deposit Instant Switch Search Platform',
  [PinwheelEvents.ProviderConfirmation]:
    'Direct Deposit Instant Switch Provider Confirmation',
  [PinwheelEvents.DDAmountSelection]:
    'Direct Deposit Instant Switch Amount Selection',
  [PinwheelEvents.DDConfirmation]: 'Direct Deposit Instant Switch Confirmation',
  [PinwheelEvents.JobSuccess]: 'Direct Deposit Instant Switch Successful',
  [PinwheelEvents.JobError]: 'Direct Deposit Instant Switch Error Encountered',
  [PinwheelEvents.ExitConfirmation]:
    'Direct Deposit Instant Switch Exit Confirmation',
  abandoned: 'Direct Deposit Instant Switch Abandoned',
};

export const PINWHEEL_LAUNCH_DEEP_LINK = 'launchPinwheel';
export const LAUNCH_VARO_DD_FORM = 'launchDDForm';
export const PINWHEEL_LAUNCH_ERROR = 'pinwheelLaunchError';
